
<div
  v-if="gagnantsMajeurs && (gagnantsMajeurs.length == 0 || gagnantsMajeurs.length == null)"
  :class="[jel_getClassObject(content)]"
  :data-component-name="$options.name"
  class="container row d-flex justify-content-center texte"
>
  {{ $t('messageComponent.resultatsIndisponibles') }}
</div>
<div v-else-if="gagnantsMajeurs" :data-component-name="$options.name">
  <ListeHorizontale :content="contentListeHorizontale" />
</div>
<div v-else :data-component-name="$options.name" class="container row texte">
  {{ $t('messageComponent.chargementEnCours') }}
</div>
